// CamberTheme.js

export const BUTTON_STYLES = {
  primary:
    "bg-camber-primary hover:bg-camber-primaryActive text-white rounded-[4px] transition-colors",
  secondary:
    "bg-camber-surface border border-camber-border text-camber-text hover:bg-camber-hover rounded-[4px] transition-colors",
  outline:
    "bg-transparent border border-camber-border text-camber-text hover:bg-camber-hover rounded-[4px] transition-colors",
  danger:
    "bg-red-500 hover:bg-red-600 text-white rounded-[4px] transition-colors",
};

export const CARD_STYLES = {
  page: "bg-camber-bg",
  surface: "bg-camber-surface rounded-[8px]",
  surfaceBordered:
    "bg-camber-surface border border-camber-border rounded-[8px]",
  tip:
    "bg-camber-surfaceAlt border border-camber-border rounded-[4px]",
};

export const TEXT_STYLES = {
  title: "text-camber-text font-extrabold",
  heading: "text-camber-text font-semibold",
  body: "text-camber-text font-normal",
  muted: "text-camber-textMuted",
  label: "text-camber-textLabel",
  placeholder: "text-camber-textPlaceholder",
};

export const INPUT_STYLES = {
  base:
    "w-full rounded-[4px] px-4 py-2 border border-camber-border bg-white " +
    "focus:outline-none focus:ring-2 focus:ring-camber-borderHover focus:border-camber-borderHover " +
    "transition",
};

export const BADGE_STYLES = {
  success: "bg-camber-successBg text-camber-successText",
  danger: "bg-camber-dangerBg text-camber-dangerText",
};

export const TABLE_STYLES = {
  headerRow: "h-[34px] border-b border-camber-border text-camber-textLabel text-[12px]",
  row:
    "h-[52px] border-b border-camber-border bg-camber-surface text-camber-text",
  rowHover:
    "hover:bg-camber-hover hover:border-camber-borderHover",
};

export const ICON_BUTTON_STYLES = {
  base:
    "w-[39px] h-[40px] rounded-[8px] flex items-center justify-center transition-colors",
  idle: "bg-transparent text-camber-icon",
  hover: "hover:bg-camber-iconBgHover hover:text-camber-primaryActive",
};
